import proj4 from "proj4";
proj4.defs("EPSG:25832",
  "+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs +type=crs"
);

proj4.defs("EPSG:25833",
  "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs +type=crs"
);


export function transformCoordinates(surfaces, mapCenter) {
    if (!surfaces || !mapCenter) {
        return surfaces;
    }

    const wgs84 = "EPSG:4326";
    const utm32 = 'EPSG:25832';

    // Transform the map center to UTM32
    const transformedCenter = proj4(wgs84, utm32, [mapCenter.lng, mapCenter.lat]);

    // Helper function to transform a single point
    const transformPoint = (point) => {
        const xValue = point[0] - transformedCenter[0];
        const yValue = point[1] - transformedCenter[1];
        const zValue = point[2];

        return [xValue, yValue, zValue];
    };

    // Transform all surfaces
    return surfaces.map(surface => {
        const transformedSurface = { ...surface };

        if (surface.geometry && surface.geometry.coordinates) {
            transformedSurface.geometry = {
                ...surface.geometry,
                // coordinates is Array(1) containing Array(5) of points
                coordinates: surface.geometry.coordinates.map(ring => 
                    ring.map(point => transformPoint(point))
                )
            };
        }

        return transformedSurface;
    });
}

                  
export function BBOxRelativeToCenter(coordinates, mapCenter = null) {
  const R = 6378137; // Earth's radius in meters
  const wgs84 = "EPSG:4326";
  const webMercator = "EPSG:3857";
  const utm32 = 'EPSG:25832';

  const transformedbboxcenter = proj4(wgs84, utm32, [mapCenter.lng, mapCenter.lat]);
  const transformebboxX =  proj4(wgs84, utm32, [coordinates[0], coordinates[1]]);
  const transformebboxY =  proj4(wgs84, utm32, [coordinates[2], coordinates[3]]);


  // console.log("Transformed Center: ", transformedbboxcenter);
  // console.log("Transformed Boundingbox: ", transformebboxX);
  // console.log("Transformed Boundingbox: ", transformebboxY);
  

//   let refX = 0;
//   let refY = 0;
//   let refZ = 0;
//   const transformPoint = (point) => {
//     const transformedCoordinates = proj4(wgs84, utm32, point);
    
  let minX,minY,maxX,maxY;
    maxX = transformebboxX[0]- transformedbboxcenter[0];
    maxY = transformebboxX[1] - transformedbboxcenter[1];
    minX = transformebboxY[0]- transformedbboxcenter[0];
    minY = transformebboxY[1] - transformedbboxcenter[1];
    

   return {maxX,maxY,minX,minY};
// };


 

}

export function wgsRelativeToCenter(coordinates, mapCenter)
{

  const latOrigin = mapCenter.lat;
  const lonOrigin = mapCenter.lng;
  const elvOrigin = mapCenter.elv;
  const METERS_PER_DEGREE_LAT = 111132;
  const metersPerDegreeLon = 111132 * Math.cos(lonOrigin * Math.PI/ 180);
 
  const transformPoint=(point)=>(
  {
    x: (point.lng - lonOrigin)* metersPerDegreeLon, // temp solution for wgs
    y: (point.lat - latOrigin)* METERS_PER_DEGREE_LAT,
    z: point.elv - elvOrigin,
   
  });
  if (Array.isArray(coordinates)) {
  
    return coordinates.map(transformPoint);
  } else {
    return transformPoint(coordinates);
  }

}


import { useMapStore } from "../store/useMapStore";
  // export function mercatorRelative(coordinates) 
  //   {
  //     const center = useMapStore.getState().center;
  //     try{
  //         const mercatorArray = coordinates.map(coordArray => {
  //           return coordArray.map(points => {
  //               const pointsarray = {
  //                   lng: points[0],  // First element is longitude
  //                   lat: points[1],  // Second element is latitude
  //                   elv: points[2],  // Third element is elevation
  //               };
  //               return mercatorRelativeToCenter(pointsarray, center);
  //           });
  //       }); 
  //       return mercatorArray;
  //     }
  //     catch(ex){
  //       console.log("Error transforming coordinates to local origin")

  //     }
  //   }

  export function mercatorRelative(coordinates) {
  const center = useMapStore.getState().center;
  
  try {
    // Helper function to determine if an item is a coordinate pair/triple
    const isCoordinate = (item) => {
      return Array.isArray(item) && 
             item.length >= 2 && 
             typeof item[0] === 'number' && 
             typeof item[1] === 'number';
    };
    
    // Recursive function to handle arbitrary nesting
    const transformNested = (data) => {
      if (isCoordinate(data)) {
        // Transform the coordinate
        const point = {
          lng: data[0],
          lat: data[1],
          elv: data[2] || 0
        };
        return BBOxRelativeToCenter(point, center);
      } else if (Array.isArray(data)) {
        // Recursively process each element
        return data.map(item => transformNested(item));
      }
      return data;
    };
    
    return transformNested(coordinates);
    
  } catch(ex) {
    console.log("Error transforming coordinates to local origin:", ex);
    return coordinates; // Return original on error
  }
}
  export function wgsRelative(coordinates) 
    {
        // Map through all coordinate arrays to maintain structure
        const mercatorArray = coordinates.map(coordArray => {
            // Map through each point in the current coordinate array
            return coordArray.map(points => {
                const pointsarray = {
                    lng: points[0],  // First element is longitude
                    lat: points[1],  // Second element is latitude
                    elv: points[2],  // Third element is elevation
                };
                return wgsRelativeToCenter(pointsarray, useMapStore.getState().center);
            });
        });
        
        return mercatorArray;
    }

 